import { NavbarGroup, NavbarHeader, NavbarItem } from '@safarilaw-webapp/shared/app-bootstrap/data-access';

export const environmentImports: NavbarItem[] | NavbarGroup[] | NavbarHeader[] = [
  // Keeping main devtools menu item to make it easier to add new items in the future, but
  // for now all that we need for RMS is covered in floating devtools dialog
  // new NavbarHeader(99000, 1, 'Dev Tools', 's_mnu-link-dev', []),
];
